<template>
  <div class="item">
    <img :src="images" alt="" @click="$emit('onClick')">
  </div>
</template>

<script>
  export default {
    name: "honor-item",
    props: {
      images: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less" scoped>
  .item {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/honor-item.vue